import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";

const defaultState = {
    showEditModal: false,
    investorAccountId: ""
};

const state = {
    ...defaultState
};

const getters = {
    investorAccountId: state => state.investorAccountId,
}
const actions = {
    setActionInvestorAccountId({
        commit
    }, payload) {
        commit(types.SET_INVESTOR_ID, payload)
    },

}
const mutations = {
    [types.SET_INVESTOR_ID](state, payload) {
        state.investorAccountId = payload;
    },
    initInvestorState(state) {
        resetStoreState(state, defaultState);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}